"use strict";

let isDialogOpened = false;

// eslint-disable-next-line no-unused-vars
function removeDialog(event) {
  const currentDialog = event.target.closest('dialog');
  currentDialog.classList.add('hide');
  currentDialog.addEventListener('animationend', function () {
    currentDialog.classList.remove('hide');
    currentDialog.close();
    // eslint-disable-next-line no-caller
    currentDialog.removeEventListener('animationend', arguments.callee, false);
    currentDialog.remove();
    isDialogOpened = false;
  }, false);
}
const renderModal = hash => {
  const couponDialogTemplated = document.querySelector('#couponDialogTemplated');
  const couponDialogTag = couponDialogTemplated.content.cloneNode(true);
  hash = hash || 'anonymous';
  couponDialogTag.querySelector('.modal__content').insertAdjacentHTML('beforeend', `<iframe id="couponIframe" src="https://24.infonito.eu/?hash=${hash}&type=web" frameborder="0"></iframe>`);
  document.body.appendChild(couponDialogTag);
  isDialogOpened = true;
};
document.addEventListener('showCoupons', eventData => {
  if (isDialogOpened === false) {
    renderModal(eventData.detail.palm_hash);
    window.couponDialog.showModal();
  } else {
    console.warn('Coupon dialog is already opened!');
  }
});